var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseS = function SvgCloseS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39989 13.3078L0.692139 12.6L6.29214 7L0.692139 1.4L1.39989 0.692253L6.99989 6.29225L12.5999 0.692253L13.3076 1.4L7.70764 7L13.3076 12.6L12.5999 13.3078L6.99989 7.70775L1.39989 13.3078Z",
    fill: "currentColor"
  })));
};
export default SvgCloseS;